import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {Program, Site} from '../../../../domain/cloud-topology';
import {ProgramService} from '../../../../services/vpp/program.service';
import {SiteService} from '../../../../services/site/site.service';
import {EventService} from '../../../../services/event.service';
import {DemandChart} from '../../../shared/demand-chart/demand-chart';
import {CombinedDemandStats} from '../../../../domain/stats';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {BaseRefreshComponent} from '../../../shared/base-refresh/base-refresh.component';
import {ChartService} from '../../../../services/chart.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-demand-profile',
  templateUrl: './program-demand-profile.component.html',
  standalone: false
})
export class ProgramDemandProfileComponent extends BaseRefreshComponent implements OnInit, OnChanges, OnDestroy {

  @Input() program: Program;
  @Input() timezone: string;
  @Input() refreshEnabled = true;
  sites: Site[];
  programDemandProfileChart: DemandChart;
  faExclamationTriangle = faExclamationTriangle;
  chartId = 'program-demand-profile-chart';
  noStats: boolean;
  loading: boolean;
  private componentDestroyed$ = new Subject<void>();

  constructor(private siteService: SiteService,
              private programService: ProgramService,
              private eventService: EventService,
              private snackBar: MatSnackBar) {
    super();

    this.eventService.sideNavButton$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.programDemandProfileChart.resize());
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.program.id) {
      this.noStats = false;

      this.setData();
    }

    if (this.refreshEnabled !== undefined && changes['refreshEnabled'] && changes['refreshEnabled']['currentValue'] !== undefined) {
      this.refreshEnabled = changes['refreshEnabled']['currentValue'];
    }
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  setData() {
    this.loading = true;
    ChartService.setGlobals(this.timezone);
    this.programService.getProgramSites(this.program).subscribe(sites => {
      if (sites) {
        this.sites = sites;
        this.programService.getCombinedDemand(this.program).subscribe(data => {
          if (data) {
            this.programDemandProfileChart = new DemandChart(this.chartId, <CombinedDemandStats>data, null, <any>{
                buildingDemand: true,
                storage: true,
                solar: true,
                enableSolar: true,
                fuelCell: true,
                enableFuelCell: true,
                loadBeforeBattery: true,
                enableLoadBeforeBattery: true,
                siteMeter: true,
              },
              this.program);
          }
          this.loading = false;
        }, (err) => {
          this.errorGettingStats();
          console.error(err);
        });
      } else {
        this.errorGettingStats();
        console.log(`No sites returned for ${this.program.name}`);
      }
    }, (err) => {
      this.errorGettingStats();
      console.log(err);
    });
  }

  private errorGettingStats() {
    this.noStats = true;
    this.loading = false;
    this.snackBar.open('Problem retrieving site data for demand graph.', 'Close', {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    });
  }
}
